import React from 'react';
import { Zap, Layers, Shield, Rocket, TrendingUp, Globe } from 'lucide-react';

const BENEFITS = [
  {
    icon: Rocket,
    title: "LEVERAGE 1:2000",
    desc: "High leverage sehingga 1:2000 untuk maximize potensi profit tanpa modal besar."
  },
  {
    icon: Zap,
    title: "FAST EXECUTION",
    desc: "Lightning-fast order execution. No requote, no slippage drama."
  },
  {
    icon: Layers,
    title: "TIGHT SPREADS",
    desc: "Premium spreads bermula dari 0.0 pips untuk major pairs. ECN pricing."
  },
  {
    icon: Shield,
    title: "REGULATED & SAFE",
    desc: "Funds segregated. Regulated broker. Trade dengan peace of mind."
  },
  {
    icon: TrendingUp,
    title: "ALL ASSETS",
    desc: "Forex, indices, crypto, commodities, metals — semua dalam satu platform."
  },
  {
    icon: Globe,
    title: "MT4 / MT5 / CXM TRADER",
    desc: "Pilih platform kegemaran kau. Semua tersedia dengan full support."
  }
];

function WhyPhyntexSection() {
  return (
    <section
      id="why-cxm"
      className="relative z-10 min-h-screen flex items-center px-3 md:px-10 py-16 md:py-24 overflow-hidden"
      style={{ perspective: "2000px" }}
      data-testid="why-cxm-section"
    >
      <div className="max-w-6xl mx-auto w-full">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span id="why-badge" className="inline-block px-4 py-2 text-xs font-inter tracking-[0.3em] uppercase text-[#00FF88] border border-[#00FF88]/30 rounded-full mb-4 will-change-transform">
            The Edge
          </span>
          <h2 id="why-title" className="font-teko text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-[#F5F5F5] leading-[0.9] will-change-transform">
            KENAPA <span className="text-[#00FF88]" style={{ textShadow: "0 0 20px rgba(0,255,136,0.5)" }}>CXM?</span>
          </h2>
          <div id="why-accent" className="mx-auto mt-4 h-[2px] w-24 md:w-32 will-change-transform" style={{ background: "linear-gradient(90deg, transparent, #00FF88, transparent)", boxShadow: "0 0 10px rgba(0,255,136,0.4)", transformOrigin: "center" }} />
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {BENEFITS.map((benefit, i) => {
            const Icon = benefit.icon;
            return (
              <div
                key={i}
                className="benefit-card relative p-6 rounded-2xl border border-[#00FF88]/15 will-change-transform group transition-all duration-500 hover:border-[#00FF88]/40"
                style={{
                  background: "linear-gradient(135deg, rgba(10,10,10,0.7) 0%, rgba(20,20,20,0.5) 100%)",
                  backdropFilter: "blur(16px)",
                  transformStyle: "preserve-3d"
                }}
                data-testid={`benefit-card-${i + 1}`}
              >
                {/* Hover Glow */}
                <div
                  className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                  style={{
                    boxShadow: "0 0 30px rgba(0,255,136,0.25), inset 0 0 20px rgba(0,255,136,0.05)"
                  }}
                />

                {/* Icon */}
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 border border-[#00FF88]/30"
                  style={{
                    background: "rgba(0,255,136,0.06)",
                    boxShadow: "0 0 15px rgba(0,255,136,0.2)"
                  }}
                >
                  <Icon className="w-6 h-6 text-[#00FF88]" />
                </div>

                {/* Content */}
                <h3 className="font-teko text-xl md:text-2xl font-bold uppercase tracking-wider text-[#F5F5F5] mb-2" style={{ textShadow: "0 0 10px rgba(0,255,136,0.15)" }}>
                  {benefit.title}
                </h3>
                <p className="text-sm text-gray-400 font-inter leading-relaxed">
                  {benefit.desc}
                </p>

                {/* Corner Accent */}
                <div className="absolute top-3 right-3 w-1.5 h-1.5 rounded-full bg-[#00FF88]" style={{ boxShadow: "0 0 8px rgba(0,255,136,0.7)" }} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default WhyPhyntexSection;
